import { render, staticRenderFns } from "./ConfiguradorItemRestaurante.vue?vue&type=template&id=20071e55&scoped=true"
import script from "./ConfiguradorItemRestaurante.vue?vue&type=script&lang=js"
export * from "./ConfiguradorItemRestaurante.vue?vue&type=script&lang=js"
import style0 from "./ConfiguradorItemRestaurante.vue?vue&type=style&index=0&id=20071e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20071e55",
  null
  
)

export default component.exports